<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner
      :background="info.image ? info.image.url : ''"
      :title="!pgLoading ? $t('auth.register') : ''"
      :subtitle="!pgLoading ? $t('auth.register') : ''"
    >
    </Banner>

    <section class="login-area grey-bg2 pt-50">
      <div class="container">
        <div class="row d-flex justify-content-center">
          <div
            class="login-section donation-form white-bg mb-30 wow fadeInUp2 animated"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: fadeInUp2;
            "
          >
            <div
              v-if="pgLoading"
              class="section-title text-left mb-50 webkit-animation webkit-100-500"
            ></div>
            <div
              v-if="!pgLoading"
              class="section-title text-left mb-50"
              :style="$i18n.locale == 'en' ? 'text-align: left !important' : ''"
            >
              <h6>
                <span :style="[locale == 'en' ? { left: 'auto' } : {}]"
                  ><i class="fas fa-heart"></i
                ></span>
                {{ $t("auth.welcome_msg") }}
              </h6>
              <h4>{{ $t("auth.register_msg") }}</h4>
            </div>

            <div class="row payment-inner">
              <form>
                <div class="row">
                  <div class="col-12">
                    <div class="input-area mb-30">
                      <input
                        type="text"
                        class="form-control"
                        v-model="row.first_name"
                        :placeholder="$t('app.name')"
                      />
                    </div>
                  </div>
                  <!-- <div class="col-12 col-lg-6">
                    <div class="input-area mb-30">
                      <input
                        type="text"
                        class="form-control"
                        v-model="row.last_name"
                        :placeholder="$t('auth.last_name')"
                      />
                    </div>
                  </div> -->
                  <div class="col-12">
                    <div class="input-area mb-30">
                      <input
                        type="email"
                        class="form-control"
                        v-model="row.email"
                        :placeholder="$t('auth.email')"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="input-area mb-20">
                      <input
                        type="password"
                        class="form-control"
                        v-model="row.password"
                        :placeholder="$t('auth.password')"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="input-area mb-20">
                      <input
                        type="password"
                        class="form-control"
                        v-model="row.password_confirmation"
                        :placeholder="$t('auth.confirm_password')"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="input-area mb-20">
                      <vue-tel-input
                        v-model="row.mobile"
                        :placeholder="$t('auth.mobile')"
                        :defaultCountry="'KW'"
                        v-on:country-changed="countryChanged"
                        style="
                          direction: ltr !important;
                          text-align: left !important;
                        "
                      >
                      </vue-tel-input>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <button
                      type="button"
                      @click="register()"
                      :disabled="btnLoading"
                      class="theme_btn theme_btn_bg"
                      style="position: inherit"
                    >
                      <div v-if="btnLoading">
                        <div class="loader loader-xs loader-center"></div>
                      </div>
                      <div v-if="!btnLoading">
                        {{ $t("auth.register") }} <span></span>
                      </div>
                    </button>
                  </div>

                  <div class="col-xl-12 mt-20 d-flex justify-content-start">
                    <h5>
                      {{ $t("auth.has_account") }}
                      <router-link :to="{ name: 'login' }">
                        {{ $t("auth.login") }}
                      </router-link>
                    </h5>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import iziToast from "izitoast";
import { VueTelInput } from "vue-tel-input";

export default {
  name: "Login",
  components: {
    Banner: () => import("@/components/Banner.vue"),
    VueTelInput,
  },
  data() {
    return {
      //
      row: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirmation: "",
        ccode: "",
        mobile: "",
      },
      locale: "ar",
      btnLoading: false,
      pgLoading: true,
      info: "",
    };
  },
  mounted() {},
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/22",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.info = res.data.info;
        })
        .catch(() => {})
        .finally(() => {});
    },

    // Register
    register() {
      if (
        !this.row.first_name ||
        !this.row.mobile ||
        !this.row.password_confirmation ||
        !this.row.password ||
        !this.row.ccode ||
        !this.row.email
      ) {
        alert(this.$t("app.allRequired"));
        return;
      }
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/auth/register",
        method: "POST",
        data: {
          first_name: this.row.first_name,
          last_name: this.row.last_name,
          email: this.row.email,
          password: this.row.password,
          password_confirmation: this.row.password_confirmation,
          ccode: this.row.ccode,
          mobile: this.row.mobile,
        },
      };
      this.$axios(options)
        .then(() => {
          this.btnLoading = false;
          this.row.password = "";
          (this.row.password_confirmation = ""),
            //
            localStorage.setItem("email_registered", this.row.email);

          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.register_msg"),
          });

          this.$router.push({ name: "login" });
        })
        .catch((err) => {
          this.btnLoading = false;
          this.row.password = "";
          this.row.password_confirmation = "";

          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: err.response
              ? this.$t("app.register_msg_failed")
              : "" + err,
          });
        });
    },

    countryChanged(country) {
      this.row.ccode = country.dialCode;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
// <style src="vue-tel-input/dist/vue-tel-input.css"></style>;

<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px;
}
.vue-tel-input {
  height: 50px;
}
.vue-tel-input .vti__dropdown {
  width: 70px !important;
}
.vue-tel-input .vti__dropdown-arrow {
  width: 50px !important;
  margin-top: -10px !important;
  position: static !important;
}
.vti__dropdown-list.below {
  z-index: 99 !important;
}
</style>

